const mobileNav = (el) => {
  if (!el) return;
  gsap.to(el, {
    opacity: 0,
    pointerEvent: "none",
    scrollTrigger: {
      trigger: ".js-footer",
      start: "top bottom",
      end: "10% bottom",
      toggleActions: "play none reverse none",
    },
  });
};
